import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FaPlus, FaMusic, FaCog, FaClock, FaLayerGroup } from 'react-icons/fa';
import './Navigation.css';
import { safeNavigate, setDirtyFlag } from './safeNavigate';

const navItems = [
  { path: '/add', label: 'Add', icon: <FaPlus /> },
  { path: '/search', label: 'AllMyTunes', icon: <FaMusic /> },
  { path: '/sets', label: 'AllMySets', icon: <FaLayerGroup /> },
  { path: '/sessions', label: 'AllMySessions', icon: <FaClock /> },
  { path: '/settings', label: 'Settings', icon: <FaCog /> }
];

const Navigation = () => {
  const navigate = useNavigate();

  return (
    <nav className="nav-container">
      {navItems.map(item => (
        <NavLink
          key={item.path}
          to={item.path}
          onClick={(e) => {
            e.preventDefault();
            safeNavigate(navigate, item.path);
          }}
          className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}
        >
          <div className="nav-icon">{item.icon}</div>
          <div className="nav-label">{item.label}</div>
        </NavLink>
      ))}
    </nav>
  );
};

export default Navigation;
